// Removed EntityState, EntityAdapter, createEntityAdapter
import { type Action, createReducer, on } from '@ngrx/store';
import type { CustomerMetadata } from '../models/customer-metadata.model'; // Added import for our model
import * as CustomerSettingsActions from './customer-settings.actions';
// Removed CustomerSettingsEntity import

export const CUSTOMER_SETTINGS_FEATURE_KEY = 'customerSettings';

// Redefined State interface for single record
export interface CustomerSettingsState {
  customerMetadata: CustomerMetadata | null; // Holds the single record
  loading: boolean;
  error: string | null; // last known error (if any)
}

export interface CustomerSettingsPartialState {
  readonly [CUSTOMER_SETTINGS_FEATURE_KEY]: CustomerSettingsState;
}

// Defined initialState based on the new State interface
export const initialState: CustomerSettingsState = {
  customerMetadata: null,
  loading: false,
  error: null,
};

const reducer = createReducer(
  initialState, // Use the new initial state
  // Handle our planned actions
  on(CustomerSettingsActions.lookupCustomer, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(
    CustomerSettingsActions.lookupCustomerSuccess,
    (state, { customerMetadata }) => ({
      ...state,
      customerMetadata, // Used property shorthand
      loading: false,
      error: null,
    })
  ),
  on(CustomerSettingsActions.lookupCustomerFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error, // Used property shorthand
  }))
);

// Updated state type hint
export function customerSettingsReducer(
  state: CustomerSettingsState | undefined,
  action: Action
) {
  return reducer(state, action);
}
